import apiClient from "../../../common/api/apiClient";
import { ForgotPasswordDto } from "./forgotPassword.dtos";
import { showNotification } from "../../../common/actionCreators/dispatchNotification";

// endpoints
const forgotPasswordUrl = "/account/forgotPassword";

export const forgotPasswordApi = async (request: ForgotPasswordDto) => {
  return await apiClient
    .post(forgotPasswordUrl, request)
    .then(_res => {
      showNotification("Forgot Password email has been sent.", "success");
      return true;
    })
    .catch(err => {
      throw err;
    });
};
